import { render, staticRenderFns } from "./zhuanyun.vue?vue&type=template&id=5f883c99&scoped=true"
import script from "./zhuanyun.vue?vue&type=script&lang=js"
export * from "./zhuanyun.vue?vue&type=script&lang=js"
import style0 from "./zhuanyun.vue?vue&type=style&index=0&id=5f883c99&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f883c99",
  null
  
)

export default component.exports